import { createFileRoute } from '@tanstack/react-router'
import PlanVersions from '../../../../../../../containers/plan-versions'
import { planVersionsRevisionSearchSchema } from '../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/planVersions/$planId/'
)({
  component: PlanVersions,
  validateSearch: planVersionsRevisionSearchSchema
})
